import { Scale, Subtract, Total } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import { HorizontalAlign } from "@pdfking/renderer-api"

import { CONTACTS } from "#constants"
import type { CalendarArea, CalendarBoxes } from "#internal"

import { DrawBadge } from "../layout/DrawBadge"
import { Area } from "./Area"
import { CaptionText } from "./CaptionText"

// The logo's height, and the lines', in the short side
const LOGO = 0.15
const NAME = 0.045
const LINE = 0.03

/** A calendar's back cover: all picture, carved round the logo high in its
 * middle, the brand's name and the address under it, and the site and the
 * mail at the foot of the frame. */
export const BackCoverAreas = ({ labels, outer, page, short }: CalendarBoxes): CalendarArea[] => {
  const logo = Scale(short, LOGO)
  const top = Total(outer.y, outer.height)
  const logo_y = Subtract(top, Total(Scale(outer.height, 0.17), logo))
  // A centred line `height` tall, its foot at `y`
  const line = (text: string, y: typeof top, height: typeof top): PageShape[] =>
    CaptionText({ ...outer, height, y }, text, HorizontalAlign.CENTER)
  const name_y = Subtract(logo_y, Scale(short, 0.08 + NAME))
  const address_y = Subtract(name_y, Scale(short, 0.015 + LINE))
  const line_height = Scale(short, LINE)
  return [
    Area.picture(page, "back", false, [
      ...DrawBadge({
        box: {
          height: logo,
          width: logo,
          x: Subtract(Total(outer.x, Scale(outer.width, 0.5)), Scale(logo, 0.5)),
          y: logo_y,
        },
        lines: [labels.LOGO_TOP(), labels.LOGO_BOTTOM()],
        spot: true,
      }),
      ...line(labels.BRAND_NAME(), name_y, Scale(short, NAME)),
      ...line(labels.ADDRESS_CITY(), address_y, line_height),
      ...CONTACTS.flatMap((contact, i) =>
        line(
          contact,
          Total(outer.y, Scale(line_height, 1.5 * (CONTACTS.length - 1 - i))),
          line_height
        )
      ),
    ]),
  ]
}
